import { Project } from "../models"

export const stateHandler = () => {
    return {
        fetchSuccess: (payload: Project) => {
            return {
                isLoaded: true,
                id: payload.id,
                ...payload.attributes,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/project/reducers/handler.ts